import { getMoney } from '@hlj/hlj-utils'
import { dGet } from '@core/utils'
import React from 'react'
import Attachments from '@common/Attachments'

export default [
  {
    dataIndex: ['cooperateorder_card', 'user_name'],
    title: '姓名'
  },
  {
    dataIndex: ['cooperateorder_card', 'user_phone'],
    title: '电话'
  },
  {
    dataIndex: ['cooperateorder_card', 'property', 'name'],
    title: '需求类型'
  },
  {
    dataIndex: ['cooperateorder_card', 'merchant', 'name'],
    title: '商家名'
  },
  {
    dataIndex: ['cooperateorder_card', 'total_money'],
    title: '订单金额',
    render: (o, { cooperateorder_card }) => {
      return getMoney(dGet(cooperateorder_card, 'total_money'))
    }
  },
  {
    dataIndex: ['cooperateorder_card', 'order_text'],
    title: '订单信息',
    render: (o, { cooperateorder_card }) => {
      const { order_text, attachments } = cooperateorder_card || {}
      return (
        <div>
          <div>{order_text}</div>
          <Attachments showUpload={false} value={attachments} />
        </div>
      )
    }
  },
  {
    dataIndex: ['operator', 'nick'],
    title: '创建人'
  },
  {
    dataIndex: ['cooperateorder_card', 'order_sub', 'parent_order_no'],
    title: '关联用户订单',
    render: parent_order_no => {
      return parent_order_no || '-'
    }
  },
  {
    dataIndex: 'created_at',
    title: '创建时间'
  }
]
